import { networkFactors } from "@/mocks/homeData";

const compareRows = [
  {
    scene: "换一条网络后能正常打开",
    result: "问题出在原网络的线路或策略上",
    tone: "primary" as const,
  },
  {
    scene: "换网络、换设备都打不开",
    result: "更可能是地址失效或站点自身故障",
    tone: "accent" as const,
  },
  {
    scene: "只有高峰时段打不开",
    result: "多半是线路拥塞，低峰期再试",
    tone: "secondary" as const,
  },
  {
    scene: "单位能开、家里打不开",
    result: "两边网络策略不同，属于正常差异",
    tone: "primary" as const,
  },
];

const toneChip: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function NetworkGuide() {
  return (
    <section id="network" className="w-full bg-foreground-950 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-400 uppercase tracking-wider">
            <i className="ri-global-line"></i>
            Blocking & Network
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50">
            网站被屏蔽？先分清是网络拦截还是站点故障
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed">
            「被屏蔽」和「站点故障」在表面上都表现为打不开，但处理方向完全不同。
            通过网络与设备之间的交叉对比，就能把两者区分开来。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {networkFactors.map((f) => (
            <div
              key={f.title}
              className="rounded-lg bg-white/5 border border-white/10 p-5 flex flex-col hover:border-accent-500/50 transition-colors"
            >
              <span className="w-11 h-11 rounded-md bg-accent-500/15 text-accent-400 flex items-center justify-center text-xl">
                <i className={f.icon}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-background-50">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-300 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-white/5 border border-white/10 overflow-hidden">
          <div className="px-5 md:px-7 py-4 border-b border-white/10 flex items-center gap-3">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center text-lg">
              <i className="ri-table-line"></i>
            </span>
            <p className="font-heading text-base font-semibold text-background-50">交叉对比判断表</p>
          </div>
          <ul className="divide-y divide-white/10">
            {compareRows.map((r) => (
              <li key={r.scene} className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6 px-5 md:px-7 py-4">
                <p className="text-sm text-foreground-300 flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-400">
                    <i className="ri-question-line"></i>
                  </span>
                  {r.scene}
                </p>
                <p className="text-sm text-background-50 flex items-center gap-2 md:justify-start">
                  <span className={`shrink-0 px-2.5 py-0.5 rounded-full text-[11px] font-medium ${toneChip[r.tone]}`}>
                    结论
                  </span>
                  {r.result}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}